module.exports = __webpack_public_path__ + "static/img/dtitle1.03f84d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/dtitle1.png
// module id = tnrc
// module chunks = 0